import { GithubComItsreverReturnsApiPkgDomainSummaryRetItem as SummaryRetItem } from '@itsrever/returns-api-types'
import NoAvailable from '@/assets/images/noAvailable.png'
import styled from 'styled-components'
import { ReturnsCalculatedSummaryReturnedItem } from '@itsrever/rever-api'
import { useTranslate } from '@/hooks'
import { useAppSelector } from '@/redux/hooks'
import { formatPrice } from '@/utils'

export interface ReturnedItemProps {
    lineItem: SummaryRetItem | ReturnsCalculatedSummaryReturnedItem
}

export const ReturnedItem: React.FC<ReturnedItemProps> = ({ lineItem }) => {
    const { translate } = useTranslate()

    const settings = useAppSelector(
        (store) => store.settingsApi.settings.response
    )

    const orderMoneyFormat =
        useAppSelector(
            (store) => store.returnsApi.order.response?.order?.money_format
        ) ?? {}

    const imgSrc = lineItem.image_url ? lineItem.image_url : NoAvailable

    const isMisako = settings.ecommerce_group === 'misako'
    const isHoff = settings.ecommerce_group === 'hoff'

    if (isHoff) {
        return (
            <div className="flex w-full flex-row items-center justify-between gap-4">
                <div className="flex h-full items-center gap-4">
                    <div className="relative my-2 h-24 w-16 overflow-hidden rounded-lg">
                        <img
                            src={imgSrc}
                            alt="ProductImage"
                            className="absolute inset-0 size-full rounded-md object-cover"
                        />
                    </div>
                    <div className="flex w-36 flex-col justify-start gap-3">
                        <div className="flex gap-2">
                            <p className="font-haas text-xs font-medium uppercase text-neutral-800">
                                {lineItem.name}
                            </p>
                        </div>
                        <p className="w-fit rounded-md  border-solid border-neutral-200 text-xs font-light text-black">
                            {lineItem.variant_name}
                        </p>
                        {lineItem.quantity && (
                            <p className="flex items-center gap-1">
                                <span
                                    className="font-haas text-xs font-normal text-neutral-500"
                                    dangerouslySetInnerHTML={{
                                        __html: translate(
                                            'product_preview_quantity'
                                        )
                                    }}
                                />
                                <span className="font-haas text-xs">
                                    {lineItem.quantity}
                                </span>
                            </p>
                        )}
                    </div>
                </div>
            </div>
        )
    }

    if (isMisako) {
        return (
            <MainDiv>
                <div className="h-36 min-w-32 lg:h-48 lg:w-40">
                    <img
                        src={imgSrc}
                        alt="ProductImage"
                        className="h-36 w-32 object-cover lg:h-48 lg:w-40"
                    />
                </div>
                <div className="ml-4 mr-6">
                    <p className="line-clamp-2 max-w-72 text-sm font-[300] tracking-wider [font-family:Inter]">
                        {lineItem.name}
                    </p>
                    {lineItem.quantity && (
                        <>
                            <span
                                className="text-xs font-[300] tracking-wider text-grey-2 [font-family:Inter]"
                                dangerouslySetInnerHTML={{
                                    __html: translate(
                                        'product_preview_quantity'
                                    )
                                }}
                            />{' '}
                            <span className="text-xs font-[300] tracking-wider text-grey-2 [font-family:Inter]">
                                {lineItem.quantity}
                            </span>
                        </>
                    )}
                    <p className="text-xs font-[300] tracking-wider text-grey-2 [font-family:Inter]">
                        {lineItem.variant_name}
                    </p>
                    <p className="mt-3 whitespace-nowrap font-[300] tracking-wider [font-family:Inter]">
                        {formatPrice(
                            Number(lineItem.total ?? 0) ?? 0,
                            orderMoneyFormat
                        )}
                    </p>
                </div>
            </MainDiv>
        )
    }

    return (
        <MainDiv>
            <div className="h-fit w-16">
                <img src={imgSrc} alt="ProductImage" />
            </div>
            <div className="ml-4 mr-6">
                <p className="text-xs">{lineItem.name}</p>
                {lineItem.quantity && (
                    <>
                        <span
                            className="text-xs text-grey-2"
                            dangerouslySetInnerHTML={{
                                __html: translate('product_preview_quantity')
                            }}
                        />
                        <span className="text-xs">{lineItem.quantity}</span>
                    </>
                )}
                <p className="mt-0.5">{lineItem.variant_name}</p>
            </div>
        </MainDiv>
    )
}

export default ReturnedItem

const MainDiv = styled.div`
    display: flex;
    width: fit-content;
    flex-direction: row;
`
